import { inject, Injectable } from '@angular/core'
import { BaseAuthConfigProvider, IAuthConfig } from '@engineering11/auth-web'
import { AppConfigService } from '@engineering11/tenant-bootstrap-web'
import { E11Logger } from '@engineering11/web-api-error'
import { AnalyticsService } from '@engineering11/web-api-firebase'
import { Store } from '@ngrx/store'
import { getBaseSuffix } from 'shared-lib'
import { environment } from '../../environments/environment'

@Injectable({ providedIn: 'root' })
export class AuthConfigProvider extends BaseAuthConfigProvider {
  constructor(private store: Store, private logger: E11Logger, private appConfig: AppConfigService) {
    super()
  }
  get config(): IAuthConfig {
    return {
      authBaseURL: environment.services.auth,
      tenantId: this.appConfig.config.auth.tenantId,
      bootstrapId: this.appConfig.config.id,
      baseSuffix: getBaseSuffix(environment, 'auth'),
    }
  }

  analytics = inject(AnalyticsService)
}
